import { render, staticRenderFns } from "./DisplayTable.vue?vue&type=template&id=6b796580&scoped=true&lang=pug&"
import script from "./DisplayTable.vue?vue&type=script&lang=ts&"
export * from "./DisplayTable.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayTable.vue?vue&type=style&index=0&id=6b796580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b796580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VSelect,VTooltip})
